/** Templates SMS par défaut (Flower / Odalys) — préremplissage côté front */

export const SMS_DEFAULT_TEMPLATES = {
    odalys: {
        triggered_sms: {
            'fr-fr': 'Offre sérénité météo Odalys Vacances activée. Consultez vos emails pour détails.',
            'en-us': 'Odalys Vacances Weather Serenity offer activated. Check your emails for details.',
            'de-de': 'Odalys Vacances Sérénité-Météo-Angebot aktiviert. Überprüfen Sie Ihre E-Mails für Details.',
            'nl-nl': 'Sérénité Météo-aanbod Odalys Vacances geactiveerd. Raadpleeg uw e-mails voor details.',
        },
        bank_account_details_reminder_sms: {
            'fr-fr': "Rappel : votre offre sérénité météo Odalys Vacances est déclenchée. N'oubliez pas de transmettre votre RIB pour recevoir votre remboursement (voir mail).",
            'en-us': "Reminder: your Odalys Vacances Weather Serenity offer has been triggered. Don't forget to send your bank details to receive your refund (see email).",
            'de-de': 'Erinnerung: Ihr Odalys Vacances Serenite-Meteo-Angebot wurde ausgelost. Vergessen Sie nicht, Ihre Bankverbindung zu übermitteln, um Ihre Rückerstattung zu erhalten (siehe E-Mail).',
            'nl-nl': 'Herinnering: uw Serenite Meteo-aanbod van Odalys Vacances is geactiveerd. Vergeet niet uw bankgegevens door te geven om uw terugbetaling te ontvangen (zie e-mail).',
        },
    },
    flower: {
        triggered_sms: {
            'fr-fr': 'Garantie météo FLOWER activée. Consultez vos emails pour détails.',
            'en-us': 'Weather guarantee FLOWER activated. Check your emails for details.',
            'de-de': 'Wettergarantie FLOWER aktiviert. Überprüfen Sie Ihre E-Mails für Details.',
            'nl-nl': 'Weergarantie FLOWER geactiveerd. Raadpleeg uw e-mails voor details.',
        },
        bank_account_details_reminder_sms: {
            'fr-fr': "Rappel : votre garantie météo Flower est déclenchée. N'oubliez pas de transmettre votre RIB pour recevoir votre remboursement (voir mail).",
            'en-us': "Reminder: your Flower weather guarantee has been triggered. Don't forget to send your bank details to receive your refund (see email).",
            'de-de': 'Erinnerung: Ihre Wettergarantie Flower wurde ausgelost. Vergessen Sie nicht, Ihre Bankverbindung zu übermitteln, um Ihre Rückerstattung zu erhalten (siehe E-Mail).',
            'nl-nl': 'Herinnering: uw Flower weergarantie is geactiveerd. Vergeet niet uw bankgegevens door te geven om uw terugbetaling te ontvangen (zie e-mail).',
        },
    },
};

export const getSmsDefaultTemplates = (brand) => SMS_DEFAULT_TEMPLATES[brand] || null;
